// extracted by mini-css-extract-plugin
module.exports = {"avatar":"RemoveImageModal_avatar_16s5Q","preview":"RemoveImageModal_preview_1dRX0"};